import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from '../jobs/jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-planning-group-work')) {
  ReactDOM.render(<JobsTable
      url = {"/api/v1/portal/planning/group-work"}
      groupWorkScreen="true"
      message_if_none = 'Jobs not found or available for viewing.'
    />,

    document.getElementById('react-component-g4-logistics-portal-planning-group-work'));
}